module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyOSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxMyIgY3k9IjEzIiByPSIxMi41IiBzdHJva2U9IiM0N0Y4NjMiLz4KICA8cGF0aCBkPSJNMTEuNSAyMkw1IDExTDExLjUgMTUuNUwyOC41IDNMMTEuNSAyMloiIGZpbGw9IiM0N0Y4NjMiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/ok.svg
// module id = 6rzM
// module chunks = 0